import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	signOutDialog: {
		display: "flex",
		gap: "8px",
		justifyContent: "flex-end",
		marginTop: "16px",
	},
});
